import { useMutation, useQueryClient } from '@tanstack/react-query';
import { likedFolderService } from 'shared/src/api';
import type { GetFolderDetailMetaResponse } from 'shared/src/api/likedFolderService/getFolderDetailMeta';
import { queryKey as sharedQueryKey } from 'shared/src/constant';
import { queryKey } from '../../../constant/queryKey';

export const useUpdateFolderInfo = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: likedFolderService.put,
    onSuccess: (_, variables) => {
      // mutation 결과로 캐시를 즉시 갱신해, refetch가 끝나기 전에도 새
      // cover_image가 반영되어 썸네일이 빈 영역/옛 값으로 깜빡이지 않도록 한다.
      queryClient.setQueryData<GetFolderDetailMetaResponse>(
        queryKey.folderDetailMeta(variables.sno),
        prev =>
          prev != null
            ? {
                ...prev,
                title: variables.title,
                cover_image: variables.image ?? null,
              }
            : prev,
      );
      queryClient.invalidateQueries({
        queryKey: queryKey.folderDetailMetaAll,
      });
      queryClient.invalidateQueries({
        queryKey: sharedQueryKey.getInfiniteLikeFolders,
      });
    },
  });
};
